import type { NdcFullInfoPackage } from 'types'
import hyphenateNdc from './hyphenateNdc'
import { checkIfProvided } from './textFormatting'

export default function getNdcText(ndcPackage: NdcFullInfoPackage | undefined | null, rxImageNdc?: string) {
  if (!ndcPackage && rxImageNdc) {
    return hyphenateNdc(rxImageNdc)
  }
  if (!ndcPackage) return 'None provided'

  const ndc = hyphenateNdc(ndcPackage.ndc)

  let packageSize
  if (ndcPackage.packageSize) {
    if (ndcPackage.innerpackCode === 'N' && ndcPackage.hasInnerPackSibling)
      packageSize = ndcPackage.packageSize?.toString() || ''
    else if (ndcPackage.packageQuantity) packageSize = (ndcPackage.packageSize * ndcPackage.packageQuantity).toString()
  }
  const packageSizeUnitOfMeasure = ndcPackage?.packageSizeUnitOfMeasure

  const displayPackSize =
    (ndcPackage.isUnbreakable || ndcPackage.hasInnerPackSibling) && !!packageSize && !!packageSizeUnitOfMeasure

  return displayPackSize ? `${ndc} (Package size: ${packageSize} ${packageSizeUnitOfMeasure})` : checkIfProvided(ndc)
}
